module.exports = __webpack_public_path__ + "02_long_black.b23736cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_long_black.png
// module id = KZ10
// module chunks = 0